import React, {useEffect, useState} from "react";
import {
    locationActions,
    membershipTypeActions,
    priceTariffsActions,
    contingentsActions,
    useSelector
} from "inbooma-api";
import {Biscuit, getAllUrlParams} from "../../../../../utils";
import showNotification from "../../../../helpers/showNotification";
import {$, moment} from "../../../../../../vendor";
import t from "../../../../helpers/t";
import {isViewVisible} from "../../../../../utils/ViewSettings";
import UserGroupSidebar from "./UserGroupSidebar";
import InboomaSubmenu from "../../../../components/InboomaSubmenu";
import SortNav from "../../../../components/SortNav";
import Loader from "../../../../components/Loader";
import UserGroupsList from "./UserGroupsList";
import UserGroupItemView from "./UserGroupItemView";
import MultipleRecipientsDialog from "../MessageComponents/MultipleRecipientsDialog";

const UserGroupsView = (props) => {
    const { dispatch, params, returnPath } = props;
    const currentUrl = new URL(window.location.href);
    const language = Biscuit.get('user.lang').replace('-','_');
    const searchParams = currentUrl.searchParams;
    const allUrlParams = getAllUrlParams(window.location.href);
    const paginationLimit = 40;
    const [pagination,setPagination] = useState({
        has_next_page: false,
        current_page: 1
    });
    const _queryState = {
        timeStamp: 0,
        value: ""
    }
    let mainMenu = document.getElementById('inb-main-menu');
    if (mainMenu !== undefined && mainMenu != null && mainMenu.querySelector('.l-users')) {
        if (mainMenu.querySelector('.active') != null) mainMenu.querySelector('.active').classList.remove('active');
        mainMenu.querySelector('.l-users').classList.add('active');
    }
    const [filters, setFilters] = useState({
        'find': '',
        'sort': 'created',
        'direction': 'desc',
        'limit': paginationLimit,
        'page' : pagination.current_page,
        ...allUrlParams
    });
    const _membershipTypes = useSelector(state => state.membership_types_data.membershipTypes);
    const _membershipType = useSelector(state => state.membership_types_data.membershipType);
    const _deleteMembershipType = useSelector(state => state.membership_types_data.deleteMembershipType);
    const _contingents = useSelector(state => state.contingents_data.contingents);
    const _pricetariffs = useSelector(state => state.price_tariffs_data.pricetariffs);
    const _locations = useSelector(state => state.locations_data.locations);
    const [membershipTypes, setMembershipTypes] = useState([]);
    const [membershipType, setMembershipType] = useState(null);
    const [membershipTypesPending, setMembershipTypesPending] = useState(false);
    const [membershipTypePending, setMembershipTypePending] = useState(false);
    const [deleteMembershipTypePending, setDeleteMembershipTypePending] = useState(false);
    const [initialized, setInitialized] = useState(false);
    const [listView, setListView] = useState(false);

    useEffect(() => {
        if(!initialized && !membershipTypesPending && !membershipTypePending){
            dispatch(priceTariffsActions.getPricetariffs({
                token: Biscuit.get('token'),
                parameters: {
                    headers: {
                        'Accept-Language': language,
                        'Content-Language': language
                    }
                }
            }));
            dispatch(locationActions.getLocations({
                token: Biscuit.get('token'),
                filter: {
                    'limit': 1000
                },
                parameters: {
                    headers: {
                        'Accept-Language': language,
                        'Content-Language': language
                    }
                }
            }));
            dispatch(contingentsActions.getContingents({
                token: Biscuit.get('token'),
                filter: {
                    'limit': 1000
                },
                parameters: {
                    headers: {
                        'Accept-Language': language,
                        'Content-Language': language
                    }
                }
            }));
            let requestFilter = {...filters};
            requestFilter = {...requestFilter, page: pagination.current_page};
            requestFilter = {...requestFilter, limit: paginationLimit};
            requestFilter = {...requestFilter, ...allUrlParams};
            dispatch(membershipTypeActions.getMembershipTypes({
                token: Biscuit.get('token'),
                filter: requestFilter,
                parameters: {
                    headers: {
                        'Accept-Language': language,
                        'Content-Language': language
                    }
                }
            }));
            setMembershipTypesPending(true);
            if(params.membershipTypeId !== null){
               dispatch(membershipTypeActions.getMembershipType({
                    token: Biscuit.get('token'),
                    id: params.membershipTypeId,
                    parameters: {
                       headers: {
                           'Accept-Language': language,
                           'Content-Language': language
                       }
                   }
               }));
               setMembershipTypePending(true);
            }
        }
    }, [])

    useEffect(() => {
        if (_membershipTypes.success === "" || !membershipTypesPending) return;

        if (_membershipTypes.success === true) {
            setMembershipTypes(_membershipTypes.data);
            setPagination(_membershipTypes.pagination);
        } else {
            console.log("Failed to request usergroups!");
        }
        setMembershipTypesPending(false);
        if(_contingents.success !== '' && _locations.success !== '' && _pricetariffs.success !== '' && !membershipTypePending){
            setInitialized(true);
        }
    },[_membershipTypes]);

    useEffect(() => {
        if (_membershipType.success === "" || !membershipTypePending) return;

        if (_membershipType.success === true) {
            setMembershipType(_membershipType.data);
        } else {
            console.log("Failed to request usergroup!");
        }
        setMembershipTypePending(false);

    },[_membershipType]);

    useEffect(() => {

        if (_deleteMembershipType.success === "" || deleteMembershipTypePending === null) {
            return;
        }

        if (_deleteMembershipType.success === true) {

            showNotification('success',null,'removed', 'usergroup');
            let clone = [...membershipTypes];
            clone.splice(deleteMembershipTypePending,1);
            setMembershipTypes(clone);
            // update user list
            /* dispatch(membershipTypeActions.getMembershipTypes({
               token: Biscuit.get('token'),
               filter: filters,
               parameters: {
                 headers: {
                   'Accept-Language': language,
                   'Content-Language': language
                 }
               }
             }));*/
        } else {
            console.log("Failed deleting usergroup!");
        }
        setDeleteMembershipTypePending(null);
    },[_deleteMembershipType]);

    const onSearchbarChanged = (ev) => {

        let query;
        if(typeof ev.target !== 'undefined') {
            query = ev.target.value.toLowerCase();
        } else {
            query = '';
        }
        searchParams.delete('q');
        if(query !== '') {
            searchParams.set('q', query);
        }
        const newRelativePathQuery = window.location.pathname + "?" + searchParams.toString();
        history.pushState(null, "", newRelativePathQuery);

        const minLength = 3;

        if (query.length >= minLength) {                                    // work user search only for values bigger or equal to the minimum length

            setTimeout(function () {

                var diff = Number(moment().format('x')) - _queryState.timeStamp;
                if (diff > 700 && _queryState.value == query) {                  // no changes after the last 700 ms -> user finished input -> start request
                    dispatch(membershipTypeActions.getMembershipTypes({
                        token: Biscuit.get('token'),
                        filter: {
                            ...filters,
                            'q': query
                           },
                        parameters: {
                            headers: {
                                'Accept-Language': language,
                                'Content-Language': language
                            }
                        }
                    }));
                    setMembershipTypesPending(true);
                    setFilters({
                        ...filters,
                        'q': query
                    });
                }
            },800);
        } else if (filters.q !== undefined) {
            // reset filter when query was active
            var clone = {...filters};
            delete clone.q;
            setFilters(clone);
            dispatch(membershipTypeActions.getMembershipTypes({
                token: Biscuit.get('token'),
                filter: {
                    ...clone
                },
                parameters: {
                    headers: {
                        'Accept-Language': language,
                        'Content-Language': language
                    }
                }
            }));
           setMembershipTypesPending(true);
        } else {
            let clone = {...filters};
            delete clone.q;
            setFilters(clone);
            dispatch(membershipTypeActions.getMembershipTypes({
                token: Biscuit.get('token'),
                filter: {
                    ...clone
                },
                parameters: {
                    headers: {
                        'Accept-Language': language,
                        'Content-Language': language
                    }
                }
            }));
        }

        _queryState.timeStamp = Number(moment().format('x'));
        _queryState.value = query;
    };

    const tabs = [{
        name: 'ID',
        smallWidth: 8,
        mediumWidth: 8,
        largeWidth: 2,
        extraClasses: 'medium-1',
        title: t('sort_by_${a}', {a: t('ID')}, 'capital'),
        canSort: true,
        sort: {
            direction: 'desc',
            data_inb_val: 'id'
        }
    }, {
        name: t('name', null, 'capital'),
        smallWidth: 8,
        mediumWidth: 8,
        largeWidth: 2,
        title: t('name', null, 'capital'),
        canSort: true,
        sort: {
            direction: 'asc',
            data_inb_val: 'name'
        }
    }, {
        name: t('domain', null, 'capital'),
        mediumWidth: 8,
        smallWidth: 8,
        largeWidth: 2,
        title: t('sort_by_${a}', {a: t('domain')}, 'capital'),
        canSort: true,
        sort: {
            direction: 'asc',
            data_inb_val: 'domain'
        }
    }
    ];

    const submenuItems = [
        {
            name: t('users',null,'capital'),
            link: 'users',
            data_inb_val: 'users',
            icon: 'fi fi-address-book',
            isActive: false,
            isAccessible: isViewVisible('users','users')
        },{
            name: t('staff',null,'capital'),
            link: 'users/staff',
            data_inb_val: 'staff',
            icon: 'fi fi-torsos-all',
            isActive: false,
            isAccessible: isViewVisible('staff','users')
        },{
            name: t('usergroups',null,'capital'),
            link: 'usersExtension/userGroups',
            data_inb_val: 'groupList',
            icon: 'fi fi-torsos-all',
            isActive: true,
            isAccessible: isViewVisible('groupList','users')
        },{
            name: t('messages',null,'capital'),
            link: 'usersExtension/messages',
            data_inb_val: 'messages',
            icon: 'fi fi-mail',
            isActive: false,
            isAccessible: isViewVisible('messages','users')
        }
    ];

    const loadNextPage = (page) => {
        setMembershipTypesPending(true);
        // request next page
        dispatch(membershipTypeActions.getMembershipTypes({
            token: Biscuit.get('token'),
            filter: {
                ...filters,
                page: page,
            },
            parameters: {
                headers: {
                    'Accept-Language': language,
                    'Content-Language': language
                }
            }
        }));
    };

    const onFilterChanged = (filter) => {

        const _filter = {'sort': 'name','direction': 'asc'};
        let clone = {...filter};

        Object.assign(clone,_filter);
        setFilters(clone);

        dispatch(membershipTypeActions.getMembershipTypes({
            token: Biscuit.get('token'),
            filter: clone,
            parameters: {
                headers: {
                    'Accept-Language': language,
                    'Content-Language': language
                }
            }
        }));
    };

    const onChangeSort = (ev) => {

        const el = ev.currentTarget;

        const sortKey = el.getAttribute('data-inb-val'),
            direction = el.getAttribute('data-inb-direction'),
            isOppositeElement = (direction === null && el.classList.contains('is-active')),
            newDirection = (direction === 'desc' || isOppositeElement ? 'asc' : 'desc');

        if (sortKey) {
            let filter = {
                sort: sortKey,
                direction: direction
            };

            setFilters(Object.assign(filters, filter));
            dispatch(membershipTypeActions.getMembershipTypes({
                    token: Biscuit.get('token'),
                    filter: filters,
                    parameters: {
                        headers: {
                            'Accept-Language': language,
                            'Content-Language': language
                        }
                    }
                }));


            const activeSortTab = $('.is-active');

            for (var tab=0;tab<activeSortTab.length;tab++) {
                activeSortTab[tab].classList.remove('is-active');
            }
            /*
            _.each(activeSortTab, function(key,value){
              key.classList.remove('is-active');
            });
            */
            el.classList.add('is-active');
            el.setAttribute('data-inb-direction', (isOppositeElement ? 'desc' : newDirection));
        }
    };

    const onDeleteUserGroup = (userGroup,key) => {

        // show warning
        if (confirm(t('really_remove'))) {
            props.dispatch(membershipTypeActions.deleteMembershipType({
                id: userGroup.id,
                token: Biscuit.get('token')
            }));
            setDeleteMembershipTypePending(key)
        }
    };

    const getList = (e,usergroup) => {
        dispatch(membershipTypeActions.getMembershipType({
            token: Biscuit.get('token'),
            id: usergroup.id
        }));
        setMembershipTypePending(true);
        setListView(true);
    };
    const closeList = (e) => {
        setMembershipType(null);
        setListView(false);
    };
    return (
        <>
            <UserGroupSidebar
                setSelectedFilter={onFilterChanged}
                activeSubmenu={'userGroup'}
                pagination={pagination}
                itemsCountPerPage={100}
                pageRangeDisplayed={5}
                onChange={loadNextPage}
            />
            <div id="inb-c-main" className="columns user">
                <InboomaSubmenu
                    tabs={submenuItems}
                    searchbar={true}
                    extraClasses={"sticky-top"}
                    searchbarPlaceholder={t('name') +' / ID / '+ t('e-mail')}
                    searchbarValue={allUrlParams?.q !== undefined ? allUrlParams.q : ""}
                    searchbarHandler={onSearchbarChanged}
                    smallOnlyTitle={t('usergroups',null,'capital')}
                    pagination={pagination}
                    itemsCountPerPage={100}
                    pageRangeDisplayed={5}
                    onChange={loadNextPage}
                    initialized={initialized}
                    itemLength={membershipTypes.length}
                />
                <SortNav
                    tabs={tabs}
                    /* margStyle={"15px"} */
                    extraClasses={"sticky-top-sortbar"}
                    handler={onChangeSort}
                />
               {/* {typeof pagination !== 'undefined' &&
                    <Paginator
                        pagination={pagination}
                        itemsCountPerPage={100}
                        pageRangeDisplayed={5}
                        onChange={loadNextPage}
                        upper={true}
                    />}*/}
                {!membershipTypesPending && membershipTypes.length > 0 &&
                    <UserGroupsList
                        membershipTypes={membershipTypes}
                        deleteMembershipTypePending={deleteMembershipTypePending}
                        onDeleteUserGroup={onDeleteUserGroup}
                        currentUrl={currentUrl}
                        getList={getList}
                        />
                }
                {!membershipTypesPending && membershipTypes.length < 1 &&
                <>
                    <div
                        id="inb-app-collection-empty"
                        className="inb-announcement"
                    >
                        <div className="inb-image-box">
                            <img alt="No Data" src={"assets/img/no_data.svg"}/>
                        </div>
                        <h3>
                            {t('app_msg_collection_empty')}
                        </h3>
                        <p>
                            {t('app_msg_collection_empty_body')}
                        </p>
                    </div>
                </>}
                {membershipTypesPending && <Loader
                    mediumWidth={2}
                    smallWidth={4}
                    subLoaders={5}/>}
            </div>
            {(params.add || (params.membershipTypeId !== null && !membershipTypePending)) && _contingents.data.length > 0 && _pricetariffs.data.length > 0 && _locations.data.length > 0 &&
                <UserGroupItemView
                    usergroup={membershipType}
                    showNotification={showNotification}
                    requestPath={returnPath}
                    dispatch={dispatch}
                    contingents={_contingents.data}
                    pricetariffs={_pricetariffs.data}
                    locations={_locations.data}
            />}
            {listView && !membershipTypePending &&
                <MultipleRecipientsDialog
                    usergroup={membershipType}
                    toggleMultipleRecipients={listView}
                    handleCloseMultipleRecipientsDialog={closeList}
                />
            }
        </>
    );
}

export default UserGroupsView;